export var baseTitle = "タダオキ｜EC事業者のための固定費0円在庫仮置き・発送代行サービス";
